import { useTypedDispatch } from "@/redux/helpers/hooks";
import { ICartItemProps } from "../../cartInterface";
import { Select } from "@/template/components";
import { updateCartItem } from "@/redux/slices/user/thunks/updateCartItem";
import { getCart } from "@/redux/slices/user/thunks/getCart";

const UsDomainContactType = ({
  item,
  reviewOrder,
}: Partial<ICartItemProps>) => {
  const dispatch = useTypedDispatch();

  const selectOptions = [
    {
      key: "P1",
      label: "Business use for profit",
    },
    {
      key: "P2",
      label: "Non-profit business, club, association, religious organisation",
    },
    {
      key: "P3",
      label: "Personal use",
    },
    {
      key: "P4",
      label: "Educational purpose",
    },
    {
      key: "P5",
      label: "Government purpose",
    },
  ];
  const personOptions = [
    {
      label:
        "A natural person (i) who is a United States citizen, (ii) who is a permanent resident of the United States of America or any of its possessions or territories, or (iii) whose primary place of domicile is in the United States of America or any of its possessions.",
      key: "C11",
    },
    {
      label:
        "A United States entity or organization that is (i) incorporated within one of the fifty (50) U.S. states, the District of Columbia, or any of the United States possessions or territories, or (ii) organized or otherwise constituted under the laws of a state of the United States of America, the District of Columbia or any of its possessions or territories (including a federal, state, or local government of the United States or a political subdivision thereof, and non-commercial organizations based in the United States)",
      key: "C21",
    },
    {
      label:
        "A foreign entity or organization that has a bona fide presence in the United States of America or any of its possessions or territories.\n" +
        "\n" +
        "By choosing this option I certify that I have a “bona fide presence in the United States” on the basis of real and substantial lawful connections with, or lawful activities in, the United States of America.",
      key: "C31",
    },
  ];

  const itemPurpose = item.extra_details.us_app_purpose;
  const itemNexusCategory = item.extra_details.us_nexus_category;

  return (
    <>
      <Select
        fullWidth
        disabled={item.loading || reviewOrder}
        loading={item.loading}
        label="Purpose"
        selected={itemPurpose}
        options={selectOptions}
        placeholder="Select An Option"
        onChange={(val) =>
          dispatch(
            updateCartItem({
              id: item.id,
              slug: `/svc/cart/domain-details/${item.id}`,
              data: {
                extra_details: {
                  us_app_purpose: val,
                  us_nexus_category: itemNexusCategory,
                },
              },
            })
          ).then(() => dispatch(getCart()))
        }
        popupProps={{
          width: 200,
          placement: "bottom-end",
        }}
      />
      <Select
        options={personOptions}
        fullWidth
        selected={itemNexusCategory}
        disabled={item.loading || reviewOrder}
        loading={item.loading}
        label="Nexus Category"
        placeholder="Select An Option"
        onChange={(val) =>
          dispatch(
            updateCartItem({
              id: item.id,
              slug: `/svc/cart/domain-details/${item.id}`,
              data: {
                extra_details: {
                  us_app_purpose: itemPurpose,
                  us_nexus_category: val,
                },
              },
            })
          ).then(() => dispatch(getCart()))
        }
        popupProps={{
          width: 200,
          placement: "bottom-end",
        }}
      />
    </>
  );
};

export default UsDomainContactType;
